<div style="display: inline-block" [class.flex]="fullWidth">
  <label [for]="inputElementId" *ngIf="!useFloatLabel && hasLabel" [style.width]="labelWidth"
         [style.flex-shrink]="fullWidth ? 0 : 1">{{ label }}</label>

  @if (!multiple) {
    @if (!useFloatLabel) {
      <ng-container *ngTemplateOutlet="singleSelect"/>
    } @else {
      <p-floatlabel [variant]="useFloatLabel">
        <ng-container *ngTemplateOutlet="singleSelect"/>
        <label>{{ label }}</label>
      </p-floatlabel>
    }
  } @else {
    @if (!useFloatLabel) {
      <ng-container *ngTemplateOutlet="multipleSelect"/>
    } @else {
      <p-floatlabel [variant]="useFloatLabel">
        <ng-container *ngTemplateOutlet="multipleSelect"/>
        <label>{{ label }}</label>
      </p-floatlabel>
    }
  }

</div>

<ng-template #singleSelect>
  <p-dropdown
    [style.max-width]="inputWidth"
    [options]="dropdownItems" [optionLabel]="optionLabel" [optionValue]="optionValue"
    [showClear]="showClear" [style.width]="inputWidth"
    appendTo="body" [placeholder]="placeholder"
    [disabled]="disabled" [filter]="showFilter"
    (onFilter)="filter($event)"
    (onHide)="onHide()"
    [resetFilterOnHide]="true"
    [ngModel]="model" (ngModelChange)="onModelChange($event)"
  >
    <ng-template let-item pTemplate="item">
      @if (optionValue && item[optionValue] <= 0 && createItemOnFly) {
        <small class="mr-2 primary-color">Crea</small> {{ item[optionLabel] }}
      } @else {
        {{ item[optionLabel] }}
      }
    </ng-template>
  </p-dropdown>
</ng-template>
<ng-template #multipleSelect>
  <p-multiSelect [selectedItemsLabel]="ellipsesText"
                 [style.width]="inputWidth" [style.max-width]="inputWidth"
                 [options]="dropdownItems"
                 [optionLabel]="optionLabel"
                 [optionValue]="optionValue"
                 [panelStyle]="{'width': inputWidth}"
                 appendTo="body" [placeholder]="placeholder"
                 [(ngModel)]="model"
                 [tooltipDisabled]="isTooltipEnabled"
                 [maxSelectedLabels]="maxSelectableElements"
                 [disabled]="disabled"
                 [autofocusFilter]="showFilter"
                 [filter]="showFilter"
                 [resetFilterOnHide]="true"
                 [pTooltip]="selectedLabels"
                 tooltipPosition="right"
  >

  </p-multiSelect>
</ng-template>
